
















































































import Vue from 'vue';
import { truncate } from 'lodash';
import props from './common/props';

export default Vue.extend({
  props: {
    ...props.detail
  },
  methods: {
    truncate
  }
});
